@if (shownComponent() === 'Builder') {
    <r1-compass-app-play-record-play-builder />
} @else if (shownComponent() === 'Importer') {
    <r1-compass-app-play-record-play-importer />
} @else {
    <p>Something went wrong. Please refresh the page.</p>
}
